﻿import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import { injectFromApp } from "../../inject";
import { RichToolTipComponent } from "../../rich-tooltip/RichToolTipComponent";

interface ILanguageSelectorItemComponentProps {
    language: string;
    resourcesStore?: IResourcesStore;
}

@injectFromApp<ILanguageSelectorItemComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@observer
export class LanguageSelectorItemComponent extends React.Component<ILanguageSelectorItemComponentProps> {
    render() {
        const { language, resourcesStore } = this.props;

        const setLanguage = () => {
            resourcesStore!.setLanguage(language);
        };

        return (
            <RichToolTipComponent
                toolTipPosition={ "left" }
                toolTipContent={ resourcesStore?.getResourceWithKey("__" + language.toLowerCase()) }
                className={ "language-item" }
                onClick={ setLanguage }
            >
                { language.substring(0, 2).toUpperCase() }
            </RichToolTipComponent>
        );
    }
}
